import type { PublicationCode } from '@/scopes/common/domain/types'

const BOOKING_URLS: Partial<Record<PublicationCode, string>> = {
  SZ: '/mijn-sunweb/boeking',
  FZ: '/mon-sunweb/booking',
  KZ: '/mit-sunweb/booking',
}

export function getBookingPageUrl(publicationCode: PublicationCode): string | null {
  return BOOKING_URLS[publicationCode] ?? null
}
